// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ModeOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_4314)"},"children":[{"tag":"path","attrs":{"d":"M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06zM17.66 3a1 1 0 00-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a1 1 0 000-1.41l-2.34-2.34a.98.98 0 00-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_4314"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"mode","theme":"outlined"};

const ModeOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ModeOutlinedSvg} />;
  ModeOutlined.displayName = 'ModeOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ModeOutlined);
